<!-- 底部公用 -->
<template>
  <div class="footBack full-width padding-top">
    <div
      class="container flex"
      :class="UI.isMobile ? 'justify-center' : 'justify-between'"
    >
      <div class="contact" :class="UI.isMobile ? 'text-center' : ''">
        <h1>联系我们</h1>
        <h3>电话: 010-67186771</h3>
        <h3>邮件: cma8848hejian@163.com</h3>
        <h3>地址: 北京市东城区体育馆路9号</h3>
      </div>

      <div class="flex align-center" v-if="!UI.isMobile">
        <div class="flex flex-direction justify-center align-center">
          <img style="height: 80px;" src="/static/img/2.png" />
          <div class="font-16 text-center margin-top-sm font-weight-500">
            国际滑雪登山联合会
          </div>
        </div>
        <div
          class="margin-left-lg flex flex-direction justify-center align-center"
        >
          <img style="height: 80px;" src="/static/img/3.png" />
          <div class="font-16 text-center margin-top-sm font-weight-500">
            亚洲滑雪登山联合会
          </div>
        </div>
        <div
          class="margin-left-lg flex flex-direction justify-center align-center"
        >
          <img style="height: 80px;" src="/static/img/1.png" />
          <div class="font-16 text-center margin-top-sm font-weight-500">
            中国登山协会
          </div>
        </div>
        <div
          class="re-logo margin-left-lg flex flex-direction justify-center align-center"
          @click="toUrl('https://pelliot.tmall.com')"
        >
          <img style="height: 80px;" src="/static/img/5.png" />
          <div class="font-16 text-center margin-top-sm font-weight-500">
            伯希和
          </div>
        </div>
        <div
          class="margin-left-lg flex flex-direction justify-center align-center"
        >
          <img style="height: 80px;" src="/static/img/4.jpg" />
          <div class="font-16 text-center margin-top-sm font-weight-500">
            公众号
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-center align-center">
      <a
        class="text-white margin-bottom-lg"
        href="https://beian.miit.gov.cn/"
        target="_blank"
      >
        吉ICP备20002389号
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['UI']),
  },

  methods: {
    toUrl(url) {
      window.open(url, '_blank');
    },
  },
};
</script>

<style lang="scss">
.footBack {
  color: #ffffff;
  font-size: 12px;
  line-height: 1.5;
  width: 100%;
  background: #003366;
}

.re-logo {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue